import { useState } from 'react'

import { EMPTY_LIST } from '../../constants/common'
import { getApi } from '../../utils/api'
import { isDevelopmentEnvironment } from '../../utils/common'
import { useAsyncCallback } from '../useAsyncCallback'

export function useTableConfigLoader({
  entity,
  handleSetSubMenu,
  tableConfigApi,
}) {
  const [isDense, setDense] = useState(false)
  const [columns, setColumns] = useState(null)
  const [requiredColumns, setRequiredColumns] = useState(null)
  const [availableFilters, setAvailableFilters] = useState(EMPTY_LIST)
  const [view, setView] = useState(null)
  const [preview, setPreview] = useState(null)

  const handleLoadTableConfig = useAsyncCallback(() => {
    return getApi({
      endpoint:
        tableConfigApi || `idwell-api/api/v3/table/tables/${entity.plural}/`,
    })
      .then(({ data }) => {
        handleSetSubMenu?.(data.sub_menu)

        setAvailableFilters(data.available_filters)

        setColumns(data.config.columns)

        setView(data.config.view)

        setPreview(data.config.preview)

        setDense(data.config.show_extra_info)

        setRequiredColumns(data.required_columns)

        return data
      })
      .catch(error => {
        if (isDevelopmentEnvironment()) {
          console.log(error)
        }

        return null
      })
  }, [entity, handleSetSubMenu, tableConfigApi])

  return {
    availableFilters,
    columns,
    handleLoadTableConfig,
    handleSetColumns: setColumns,
    handleSetDense: setDense,
    handleSetPreview: setPreview,
    handleSetView: setView,
    isDense,
    preview,
    requiredColumns,
    view,
  }
}
